<template>
  <div class="payment-choice-content">
    <QCardSection>
      <QList>
        <QItem dense>
          <IconLabel
            heavy
            no-padding
            :label="$tc('ETAB.PAGES.SUBSCRIPTION.@OFFER_CHOSEN', selectedOffer.getMonthDuration())"
            icon="icon-extra-check"
          />
        </QItem>
        <QItem>
          <QItemLabel>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <p v-html="$t('ETAB.PAGES.SUBSCRIPTION.@OFFER_PRICE', { amount: selectedOffer.getAmountHt() })" />
          </QItemLabel>
        </QItem>

        <QSeparator spaced inset />

        <QItem dense>
          <IconLabel heavy no-padding :label="$t('ETAB.PAGES.SUBSCRIPTION.@START_DATE')" icon="icon-extra-date" />
        </QItem>
        <QItem>
          <QItemLabel>
            <p>{{ displayDuration }}</p>
          </QItemLabel>
        </QItem>

        <QSeparator spaced inset />

        <QItem dense>
          <IconLabel heavy no-padding :label="$t('ETAB.PAGES.SUBSCRIPTION.@PAYMENT_METHOD')" icon="icon-extra-bank" />
        </QItem>
        <QItem>
          <QItemSection>
            <QItemSection>
              <ExtraMultiBtn v-model="paymentChoice" :options="paymentOptions" :grey-unselected="true" />
            </QItemSection>
          </QItemSection>
        </QItem>

        <QSeparator spaced inset />
      </QList>
    </QCardSection>

    <QCardSection class="text-center">
      <QBtn
        v-close-popup
        :label="$t('ETAB.PAGES.SUBSCRIPTION.LABELS.@PAY')"
        no-caps
        class="btn-navigation btn-large q-mb-md"
        color="secondary"
        @click="$emit('selectPaymentChoice', paymentChoice)"
      />
      <br />
      <QBtn v-close-popup no-caps flat class="text-underline btn-navigation btn-large" :label="$t('ETAB.PAGES.SUBSCRIPTION.LABELS.@CANCEL')" />
    </QCardSection>
  </div>
</template>

<script>
  import { SubscriptionOffersModel } from "@core/models";
  import { PAYMENT_SESSION } from "@core/constants";

  export default {
    props: {
      selectedOffer: {
        type: Object,
        default: () => new SubscriptionOffersModel(),
      },
      paymentSessions: {
        type: Array,
        default: () => [],
      },
      formattedDateNow: {
        type: String,
        default: "",
      },
    },
    emits: ["selectPaymentChoice"],
    data() {
      return {
        // we set credit card payment choice by default
        paymentChoice: PAYMENT_SESSION.CB_SESSION,
      };
    },
    computed: {
      paymentOptions() {
        return this.paymentSessions.map((session) => {
          return {
            label: session.getLabel(),
            value: session.getCode(),
          };
        });
      },
      displayDuration() {
        if (this.selectedOffer.getMonthDuration()) {
          return this.$t("ETAB.PAGES.SUBSCRIPTION.@START_DATE_WITH_ENGAGEMENT", {
            startDate: this.formattedDateNow,
            endDate: this.selectedOffer.getFormattedEndDate(),
          });
        }
        return this.$t("ETAB.PAGES.SUBSCRIPTION.@START_DATE_WITHOUT_ENGAGEMENT", {
          startDate: this.formattedDateNow,
        });
      },
    },
    created() {
      // if paymentOptions has a "cb-session" option, keep it default, otherwise set first option as fallback
      const foundDefaultCBSession = this.paymentOptions.find((option) => option.value === PAYMENT_SESSION.CB_SESSION);
      if (!foundDefaultCBSession) {
        this.paymentChoice = this.paymentOptions[0]?.value;
      }
    },
  };
</script>
